import Image from 'next/image';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Calendar from 'react-calendar';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { AttractionCheckoutContext } from '../../utils/attractionCheckoutContext';
import { ATTRACTION } from '../../pages/[slug]/[slug2]';
import { PaxContext } from '../../utils/context/checkoutContext';
interface TopTip {
  id: string;
  text: string;
  likes: number;
  dislikes: number;
}
type PASSENGERINFO = {
  count: number;
  label: string;
  title: string;
  price: number;
};
export type PASSENGERPAX = {
  adults: PASSENGERINFO;
  children?: PASSENGERINFO;
  infants?: PASSENGERINFO;
};
interface Top {
  top_tips: TopTip[];
}
interface Iroprs {
  setIsModalOpen: (open: boolean) => void;
  attraction: ATTRACTION;
}
interface DayContainerProps {
  active: boolean;
}
interface StyledProps {
  modal: boolean;
}
const StyledCelendar = styled(Calendar)<StyledProps>`
  position: absolute;
  z-index: 100;
  width: 100%;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 945px) {
    max-width: 100%;
  }
  .react-calendar__month-view__days {
    min-height: 300px;
    height: ${props => (props.modal ? '295px' : '265px')};
    width: 100%;
    @media (max-width: 1800px) {
      height: 295px;
    }
    @media (max-width: 945px) {
      height: ${props => (props.modal ? '285px' : '200px')};
    }
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
  }
  .react-calendar__navigation__prev2-button {
    display: none;
  }
  .react-calendar__navigation {
    margin-bottom: 0;
    height: 35px;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    margin: 10px;
  }
  .react-calendar__viewContainer {
    padding: 10px;
    height: 100%;
    width: 100%;
  }
  .react-calendar__tile {
    padding: 6px 6.6667px;
  }
  .react-calendar__tile--active {
    background: #1f2c5b;
    color: #fff;
  }
  .react-calendar__navigation__label {
    pointer-events: none;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__navigation__next2-button {
    display: none;
  }
`;
const DayContainer = styled.div<DayContainerProps>`
  color: ${props => (props.active ? 'white' : 'black')};
  .react-calendar__month-view__days__day {
    background: gray;
  }
  .price {
    color: ${props => (props.active ? 'white' : '#6b7280')};
    font-size: 12px;
  }

  display: flex;
  flex-direction: column;
`;
const DateAndPaxModal = ({ setIsModalOpen, attraction }: Iroprs) => {
  const {
    tickets,
    attraction_availability: {
      prices: { adults, children, infants },
      limit
    }
  } = attraction;

  const handleSubmit = async () => {};
  const [isOpen, setIsOpen] = useState(true);
  const [totalCount, setCount] = useState<number>(1);
  const modalRef: any = useRef(null);
  const timeSlots = ['09:00 AM', '02:00 PM', '03:00 PM', '06:00 PM'];
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
  const handleSlotClick = (timeSlot: string) => {
    setSelectedSlot(prevSelectedSlot =>
      prevSelectedSlot === timeSlot ? null : timeSlot
    );
  };

  const handleCloseModal = (e: any) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setIsModalOpen(false);
    }
  };
  const [selectedDate, setSelectedDate] = useState<string>(
    dayjs().format('YYYY-MM-DD')
  );
  const [mobileCalendar, setMobileCalendar] = useState<boolean>(false);

  const [passengerPax, setPassengerPax] = useState<PASSENGERPAX>(() => {
    return {
      adults: {
        count: 1,
        label: 'Adult',
        price: adults,
        title: 'Adult'
      },
      children: {
        count: 0,
        label: 'Child',
        price: children,
        title: 'Children'
      },
      infants: {
        count: 0,
        label: 'Infant',
        price: infants,
        title: 'Infant'
      }
    };
  });
  const [totalPrice, setTotalPrice] = useState<number>(() =>
    Number(passengerPax?.adults.price)
  );
  useEffect(() => {
    document.addEventListener('mousedown', handleCloseModal);
    return () => {
      document.removeEventListener('mousedown', handleCloseModal);
    };
  }, []);
  useEffect(() => {
    const adults =
      passengerPax.adults.count * Number(passengerPax.adults.price);
    const children = passengerPax.children
      ? passengerPax.children.count * Number(passengerPax.children.price)
      : 0;
    const infants = passengerPax.infants
      ? passengerPax.infants.count * Number(passengerPax.infants.price)
      : 0;

    const childrenCount = passengerPax.children
      ? passengerPax.children.count
      : 0;
    const infantsCount = passengerPax.infants ? passengerPax.infants.count : 0;
    const totalCount = passengerPax.adults.count + childrenCount + infantsCount;
    setCount(totalCount);
    setTotalPrice(() => Number(adults + children + infants));
  }, [passengerPax]);

  const router = useRouter();
  const { updateCheckoutDetails, updateAttraction } = useContext(
    AttractionCheckoutContext
  );

  const proceedToCheckout = () => {
    updateCheckoutDetails({
      ...passengerPax,
      amount: totalPrice,
      currency: 'usd',
      attractionName: attraction.name,
      date: selectedDate
    });
    updateAttraction(attraction);
    router.push('/attraction-checkout');
  };
  {
    /* Modal Wrapper z-index should be 1150 or in between 1100 and 1200 */
  }
  return (
    <div className="fixed inset-0  z-[1150] bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div
        ref={modalRef}
        className={`bg-white xxsm:mt-[20px] md:mt-[60px] rounded-[24px] w-[90%] md:w-[530px]  `}
      >
        <div className=" mt-2 mr-2 flex justify-end">
          <span
            className="cursor-pointer px-2 py-1"
            onClick={() => setIsModalOpen(false)}
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.398438"
                y="0.5"
                width="20.5989"
                height="20"
                rx="10"
                fill="#DEDEDE"
              />
              <path
                d="M14.7681 7.51358C14.8398 7.44442 14.897 7.36169 14.9363 7.27021C14.9757 7.17872 14.9964 7.08032 14.9973 6.98074C14.9982 6.88115 14.9793 6.78238 14.9416 6.69019C14.904 6.598 14.8483 6.51424 14.7779 6.44379C14.7076 6.37333 14.6238 6.31761 14.5317 6.27985C14.4395 6.2421 14.3408 6.22307 14.2412 6.22389C14.1416 6.22471 14.0432 6.24535 13.9517 6.28462C13.8602 6.32388 13.7774 6.38098 13.7081 6.45258L10.7021 9.45758L7.69715 6.45258C7.62848 6.37889 7.54568 6.31979 7.45368 6.27879C7.36168 6.2378 7.26237 6.21576 7.16167 6.21398C7.06097 6.21221 6.96094 6.23073 6.86755 6.26845C6.77416 6.30617 6.68933 6.36232 6.61811 6.43354C6.54689 6.50476 6.49074 6.58959 6.45302 6.68298C6.4153 6.77637 6.39678 6.8764 6.39855 6.9771C6.40033 7.0778 6.42237 7.17711 6.46336 7.26911C6.50436 7.36111 6.56346 7.44391 6.63715 7.51258L9.64015 10.5186L6.63515 13.5236C6.50267 13.6658 6.43054 13.8538 6.43397 14.0481C6.4374 14.2424 6.51611 14.4278 6.65352 14.5652C6.79094 14.7026 6.97632 14.7813 7.17062 14.7847C7.36492 14.7882 7.55297 14.7161 7.69515 14.5836L10.7021 11.5786L13.7071 14.5846C13.8493 14.7171 14.0374 14.7892 14.2317 14.7858C14.426 14.7823 14.6114 14.7036 14.7488 14.5662C14.8862 14.4288 14.9649 14.2434 14.9683 14.0491C14.9717 13.8548 14.8996 13.6667 14.7671 13.5246L11.7641 10.5186L14.7681 7.51358Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
        <h2 className="px-[4%] text-[18px] xl:text-[22px] font-semibold flex justify-center">
          {attraction?.name}
        </h2>

        <div className="xxsm:px-4  md:px-14 md:py-4 xxsm:py-3 xl:py-6">
          <div className="h-auto">
            <div
              onClick={(e: any) => {
                e.stopPropagation();
                setMobileCalendar(!mobileCalendar);
              }}
              className="border rounded border-gray-300 w-full mb-3  md:mb-6 px-4 py-2 gap-2 flex relative items-center hover:cursor-pointer"
            >
              <Image
                src="/calendar.svg"
                width={10}
                height={10}
                alt="calendar"
              />
              <span className="xxsm:text-[14px] sm:text-[16px] text-black ">
                {selectedDate}
              </span>
              <div
                className={`rotate-180 ${
                  mobileCalendar && 'rotate-0'
                } absolute  right-3 `}
              >
                <Image
                  src="/dropDown.png"
                  width={10}
                  height={10}
                  alt="dropdown"
                  className="hover:cursor-pointer"
                />
              </div>
            </div>
            {mobileCalendar && (
              <div className="relative bg-[#FAFAFA] rounded-[5px] ">
                <StyledCelendar
                  tileContent={({ activeStartDate, date, view }) => (
                    <DayContainer
                      active={
                        selectedDate === dayjs(date).format('YYYY-MM-DD')
                          ? true
                          : false
                      }
                    ></DayContainer>
                  )}
                  // @ts-ignore
                  modal={true}
                  minDate={new Date()}
                  showNeighboringMonth={false}
                  onClickDay={(value: any) => {
                    setSelectedDate(dayjs(value).format('YYYY-MM-DD'));
                    setMobileCalendar(false);
                  }}
                  value={new Date(selectedDate)}
                />
              </div>
            )}
          </div>
          <div>
            <div
              onClick={() => setIsOpen(!isOpen)}
              className="flex justify-between z-[9999] cursor-pointer bg-white pb-2 border border-gray-300 rounded-md py-2 pl-2 items-center align-middle text-black"
            >
              <div className="flex">
                <div className="hidden msm:flex">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="vuesax/outline/user">
                      <g id="user">
                        <path
                          id="Vector"
                          d="M9 9.5625C6.6225 9.5625 4.6875 7.6275 4.6875 5.25C4.6875 2.8725 6.6225 0.9375 9 0.9375C11.3775 0.9375 13.3125 2.8725 13.3125 5.25C13.3125 7.6275 11.3775 9.5625 9 9.5625ZM9 2.0625C7.245 2.0625 5.8125 3.495 5.8125 5.25C5.8125 7.005 7.245 8.4375 9 8.4375C10.755 8.4375 12.1875 7.005 12.1875 5.25C12.1875 3.495 10.755 2.0625 9 2.0625Z"
                          fill="#292D32"
                        />
                        <path
                          id="Vector_2"
                          d="M15.4397 17.0625C15.1322 17.0625 14.8772 16.8075 14.8772 16.5C14.8772 13.9125 12.2372 11.8125 8.99718 11.8125C5.75718 11.8125 3.11719 13.9125 3.11719 16.5C3.11719 16.8075 2.86219 17.0625 2.55469 17.0625C2.24719 17.0625 1.99219 16.8075 1.99219 16.5C1.99219 13.2975 5.13468 10.6875 8.99718 10.6875C12.8597 10.6875 16.0022 13.2975 16.0022 16.5C16.0022 16.8075 15.7472 17.0625 15.4397 17.0625Z"
                          fill="#292D32"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="text-black ml-2 xxsm:text-[14px] sm:text-[16px]">
                  {Object.values(passengerPax)
                    .filter(item => typeof item === 'object' && item?.count > 0)
                    .map((item, index, array) => {
                      if (typeof item === 'object' && item?.count > 0) {
                        // @ts-ignore
                        return `${item.label} ${item.count}X ${
                          index === array.length - 1 ? '' : ', '
                        }`;
                      }
                      return '';
                    })}
                </span>
              </div>
              <button
                className={`bg-white px-4 py-2 rounded-md rotate-180 text-left transition-transform transition-fast ${
                  isOpen && 'rotate-0'
                } `}
              >
                <Image
                  src="/dropDown.png"
                  width={10}
                  height={10}
                  alt="dropdown"
                />
              </button>
            </div>
            {totalCount >= limit && (
              <p className=" text-[#1F2C5B] md:text-base text-center mt-[5px]  md:mt-[16px]">
                {' '}
                Maximum limit of seats reached{' '}
              </p>
            )}
          </div>
          <div
            className={` rounded-xl border border-solid border-gray-300 bg-[#FAFAFA] shadow-lg xxsm:p-2 msm:p-3 relative md:relative right-0 mt-[5px] md:mt-4 w-full ${
              !isOpen ? 'hidden' : ''
            }`}
          >
            <>
              {' '}
              <div className="grid grid-cols-4">
                <div className="col-span-2 flex flex-col  px-2   ">
                  <div className="flex items-center ">
                    <span className="text-black">
                      {`${passengerPax.adults.label}\u00a0`}
                    </span>{' '}
                    <span className="text-black text-[10px]">
                      {passengerPax.adults.label === 'Quantity'
                        ? '(All ages)'
                        : '(Ages 13+)'}
                    </span>
                  </div>
                  <div className=" flex justify-start ">
                    <div className="flex items-center ">
                      <span className=" text-[#1F2C5B]  text-sm ">
                        ${passengerPax.adults.price}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-span-2 grid grid-cols-3">
                  <div className="flex justify-center items-center  ">
                    <button
                      onClick={() => {
                        if (passengerPax.adults.count <= 1) return;

                        setPassengerPax({
                          ...passengerPax,
                          adults: {
                            ...passengerPax.adults,
                            count: passengerPax.adults.count - 1
                          }
                        });
                      }}
                      className="col-span-1 rounded-full w-8 h-8 bg-white border-2  text-black"
                    >
                      -
                    </button>
                  </div>
                  <div className="flex justify-center items-center ">
                    <span className="col-span-1 text-center text-[#1F2C5B] ">
                      {passengerPax.adults.count}
                    </span>
                  </div>{' '}
                  <div className="flex justify-center items-center ">
                    <button
                      onClick={() => {
                        if (totalCount >= limit) {
                          return;
                        }
                        setPassengerPax({
                          ...passengerPax,
                          adults: {
                            ...passengerPax.adults,
                            count: passengerPax.adults.count + 1
                          }
                        });
                      }}
                      className="col-span-1 rounded-full   w-8 h-8 bg-white border-2  text-black"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              {passengerPax.children &&
                Number(passengerPax.children.price) !== 0 && (
                  <div className="grid grid-cols-4">
                    <div className="col-span-2 flex flex-col   px-2 ">
                      <div className="flex items-center">
                        <span className="text-black">
                          {`${passengerPax.children.label}\u00a0`}
                        </span>
                        <span className="text-black    text-[10px] ">
                          {passengerPax.children.label === 'Child' &&
                            '(Ages 5-12)'}
                          {passengerPax.children.label === 'Infant' &&
                            '(Ages 0-5)'}
                        </span>
                      </div>
                      <div className="col-span-1 flex justify-start ">
                        <div className="flex items-center text-gray-500 ">
                          <span className=" text-[#1F2C5B]  text-sm">
                            ${passengerPax.children.price}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-span-2 grid grid-cols-3">
                      <div className="flex justify-center items-center ">
                        <button
                          onClick={() => {
                            if (
                              passengerPax.children &&
                              passengerPax.children.count > 0
                            ) {
                              setPassengerPax({
                                ...passengerPax,
                                children: {
                                  ...passengerPax.children,
                                  count: passengerPax.children.count - 1
                                }
                              });
                            }
                          }}
                          className="col-span-1 rounded-full    w-8 h-8 bg-white border-2  text-black"
                        >
                          -
                        </button>
                      </div>
                      <div className="flex justify-center items-center ">
                        <span className="col-span-1 text-center text-[#1F2C5B] ">
                          {passengerPax.children.count}
                        </span>
                      </div>{' '}
                      <div
                        onClick={() => {
                          if (passengerPax.children) {
                            if (totalCount >= limit) {
                              return;
                            }
                            setPassengerPax({
                              ...passengerPax,
                              children: {
                                ...passengerPax.children,
                                count: passengerPax.children.count + 1
                              }
                            });
                          }
                        }}
                        className="flex justify-center items-center "
                      >
                        <button className="col-span-1 rounded-full   w-8 h-8 bg-white border-2  text-black">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              {passengerPax.infants && (
                <div className="grid grid-cols-4">
                  <div className="col-span-2 flex flex-col  px-2 ">
                    <div className="flex items-center">
                      <span className="text-black">
                        {`${passengerPax.infants.label}\u00a0`}
                      </span>
                      <span className="text-black    text-[10px] ">
                        {passengerPax.infants.label === 'Child' &&
                          '(Ages 5-12)'}
                        {passengerPax.infants.label === 'Infant' &&
                          '(Ages 0-5)'}
                      </span>
                    </div>
                    <div className="col-span-1 flex justify-start ">
                      <div className="flex items-center ">
                        <span className=" text-[#1F2C5B]  text-sm   ">
                          ${passengerPax.infants.price}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-2 grid grid-cols-3">
                    <div className="flex justify-center items-center ">
                      <button
                        onClick={() => {
                          if (
                            passengerPax.infants &&
                            passengerPax.infants.count > 0
                          ) {
                            setPassengerPax({
                              ...passengerPax,
                              infants: {
                                ...passengerPax.infants,
                                count: passengerPax.infants.count - 1
                              }
                            });
                          }
                        }}
                        className="col-span-1 rounded-full    w-8 h-8 bg-white border-2  text-black"
                      >
                        -
                      </button>
                    </div>
                    <div className="flex justify-center items-center ">
                      <span className="col-span-1 text-center text-[#1F2C5B] ">
                        {passengerPax.infants.count}
                      </span>
                    </div>{' '}
                    <div className="flex justify-center items-center ">
                      <button
                        onClick={() => {
                          if (totalCount >= limit) {
                            return;
                          }
                          if (passengerPax.infants) {
                            setPassengerPax({
                              ...passengerPax,
                              infants: {
                                ...passengerPax.infants,
                                count: passengerPax.infants.count + 1
                              }
                            });
                          }
                        }}
                        className="col-span-1 rounded-full   w-8 h-8 bg-white border-2  text-black"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <p className="pl-2 text-xs">Prices shown in USD</p>
            </>
          </div>

          <h2 className="text-[16px] font-semibold mt-3 ">
            Operational Hours:
          </h2>
          <span className="font-medium xxsm:text-[14px] sm:text-[16px]">
            {router.asPath === '/niagara-falls-tours-canada/Niagara-Helicopters'
              ? `9am - 7pm`
              : `24 Hours`}
          </span>

          <button
            onClick={() => proceedToCheckout()}
            className=" bg-[#1F2C5B] rounded-md py-3 text-white p-6 w-full my-[5px] md:my-4"
          >
            Book now ${totalPrice.toFixed(2)}
          </button>
          {/* <div className="border-t border-solid border-gray-300 mb-8">
              <h2 className="text-[16px] font-semibold mt-6 ">
                Available Time Slots{' '}
              </h2>
              <div className="flex gap-4 mt-4 flex-wrap">
                {timeSlots.map((timeSlot, index) => (
                  <div
                    onClick={() => handleSlotClick(timeSlot)}
                    key={index}
                    className={`flex-shrink-0 w-28 h-12 p-2 flex justify-center text-[16px] items-center gap-2 cursor-pointer rounded-[8px] border border-solid ${
                      selectedSlot === timeSlot
                        ? 'bg-[#FD5D5A] border-[#FD5D5A] text-white'
                        : 'border-[#5B5B5B] bg-white'
                    }`}
                  >
                    {timeSlot}
                  </div>
                ))}
              </div>
            </div> */}
          <div className="flex items-start gap-2  mt-2  slide-in   ">
            <Image
              src="/tick-square.svg"
              width={24}
              height={24}
              alt="tick mark"
              className="xxsm:w-[20px] sm:w-[24px]"
            />
            <span className="font-medium xxsm:text-[14px] sm:text-[16px]">
              Lowest price guarantee{' '}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateAndPaxModal;
